export const channelSearchConstants = {
    ALL: 'AUTHOR_ALL_IN',
    GET_DAY:'GET_NOW_DATE',
    SET_TIME_STATUS:'SET_TIME_STATUS',
    A_KEY:'AUTHOR_KEY',
    A_NAME:'AUTHOR_NAME',
    SET_DOCS:'SET_ALLDOCS',
    REQUEST_AUTHOR_DETAIL:'REQUEST_AUTHOR_DETAIL_DATA',
    RECEIVE_AUTHOR_DETAIL:'RECEIVE_AUTHOR_DETAIL_DATA',
    REQUEAT_SUNBURST:'REQUEAT_AUTHOR_SUNBURST',
    RECEIVE_SUNBURST:'RECEIVE_AUTHOR_SUNBURST',
    SWITCH_TYPE:"SWITCH_SEARCH_TYPE",
    //youtuber
    REQUEST_YT_SEARCH:'REQUEST_YOUTUBER_SEARCH',
    RECEIVE_YT_SEARCH:"RECEIVE_YOUTUBER_SEARCH",
    REQUEST_YT_DETAIL:"REQUEST_YOUTUBER_DETAIL",
    RECEIVE_YT_DETAIL:"RECEIVE_YOUTUBER_DETAIL",
    RECEIVE_YT_COMMENT:"RECEIVE_COMMENT_SENTIMENT_DATA_BY_DATE",
    RECEIVE_YT_SENTIMENT:"RECEIVE_YOUTUBER_SENTIMENT",
    RECEIVE_FANS_ACTIVITY:"RECEIVE_FANS_ACTIVITY",
    RECEIVE_FANS_PATH:"RECEIVE_FANS_PATH",
    RECEIVE_FANS_LIST:"RECEIVE_FANS_LIST",
    RECEIVE_FANS_COMMENT:"RECEIVE_FANS_COMMENT",
    RECEIVE_COMMENT_SENTIMENT:"RECEIVE_COMMENT_SENTIMENT",
    RECEIVE_COMMENT_TIME:"RECEIVE_COMMENT_TIME",
    RECEIVE_VIDEOS:"RECEIVE_VIDEOS",
    RECEIVE_VIDEO:"RECEIVE_VIDEO",
    RECEIVE_VIDEO_ACTIVITY:"RECEIVE_VIDEO_ACTIVITY",
    RECEIVE_VIDEO_SENTIMENT:"RECEIVE_VIDEO_SENTIMENT",
    RECEIVE_VIDEO_TERMS:"RECEIVE_VIDEO_TERMS",
    RECEIVE_VIDEO_STATUS:"RECEIVE_VIDEO_STATUS",
    RECEIVE_VIDEO_COMMENTS:"RECEIVE_VIDEO_COMMENTS",
    //facebook 
    REQUEST_FB_SEARCH:'REQUEST_FACEBOOK_SEARCH',
    RECEIVE_FB_SEARCH:"RECEIVE_FACEBOOK_SEARCH",
    REQUEST_FB_DETAIL:"REQUEST_FACEBOOK_DETAIL",
    RECEIVE_FB_DETAIL:"RECEIVE_FACEBOOK_DETAIL",


};


// WEBPACK FOOTER //
// ./src/constants/channelSearch.constants.js